import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// ErrorBoundary를 쓰고 있다면 유지
import ErrorBoundary from "./components/ErrorBoundary";

// ═══════════════════════════════════════════════════════
// 🔑 axios 전역 토큰 자동첨부 (2026 추가)
//   api/axios.js, http.js 에는 interceptor 가 있으나
//   `import axios from "axios"` 로 직접 쓰는 파일들에는 토큰이 안 붙어
//   백엔드 등급검사(authJwtMw)에서 401 을 받게 됨
// ═══════════════════════════════════════════════════════
import axios from "axios";
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ═══════════════════════════════════════════════════════
// 🔑 fetch 전역 토큰 자동첨부 (2026 추가)
//   매물 목록(api/propertyApi.js), 사진 등 상당수가 fetch() 를 직접 사용
//   → 토큰이 안 붙어 서버가 "비로그인"으로 판단, 관리자도 정보가 가려짐
//
//   동작: 주소에 "/api/" 가 있을 때만 토큰 첨부
//        → 카카오맵 등 외부 요청에는 우리 토큰이 새어나가지 않음
//   연관: backend/routes/properties.js 의 softAuth
// ═══════════════════════════════════════════════════════
const _origFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  try {
    const urlStr = typeof input === "string" ? input : (input?.url || "");
    if (urlStr.includes("/api/")) {
      const token = localStorage.getItem("token");
      const headers = new Headers(init.headers || {});
      if (token && !headers.has("Authorization")) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      init = { ...init, headers };
    }
  } catch (e) {
    // 실패해도 원래 요청은 그대로 진행 (화면이 멈추지 않도록)
    console.warn("[fetch wrapper]", e.message);
  }
  return _origFetch(input, init);
};

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(rs => rs.forEach(r => r.unregister()));
  }
  if (window.caches) {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode 제거 (이중 마운트로 인한 타이밍/TDZ 이슈 방지)
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
